import React, { useRef } from 'react';
import useOutsideClick from './datePicker/hooks/useOutsideClick';
import { createPortal } from 'react-dom';
import { twMerge } from 'tailwind-merge';

interface TableFilterPopupWrapperProps {
  children: React.ReactNode;
  closeOptions: () => void;
  container: HTMLElement;
  className?: string;
  open: boolean;
}

const TableFilterPopupWrapper: React.FC<TableFilterPopupWrapperProps> = ({
  closeOptions,
  open,
  children,
  container,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useOutsideClick(ref, closeOptions, open);

  return createPortal(
    <div
      onClick={(event) => event.stopPropagation()}
      ref={ref}
      className={twMerge(
        'z-40 desktop:w-[340px] w-[320px] border rounded-xl bg-white border-gray-opacity-15 top-32 absolute desktop:top-12 -right-5 desktop:right-0',
        className,
      )}
    >
      {children}
    </div>,
    container,
  );
};

export default TableFilterPopupWrapper;
